// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"signup_wrapper__GNZDW","heading":"signup_heading__SA6qM","subtitle":"signup_subtitle__P8MsS"};